import React, { useState } from 'react';
import Header from '../components/Header';
import NavigationMenu from '../components/NavigationMenu';
import Card from '../components/Card';
import { ChevronRightIcon } from 'lucide-react';
const AgreementManagement = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const handleMenuToggle = () => {
    setMenuOpen(!menuOpen);
  };
  // Sample agreements data
  const agreements = [{
    id: 'A001',
    client: 'Juan Carlos Rodríguez',
    date: '2023-05-15',
    status: 'Activo',
    value: '$2,450,000',
    statusColor: 'green'
  }, {
    id: 'A002',
    client: 'María López',
    date: '2023-05-10',
    status: 'Pendiente',
    value: '$1,830,000',
    statusColor: 'amber'
  }, {
    id: 'A003',
    client: 'Pedro Gómez',
    date: '2023-05-05',
    status: 'Vencido',
    value: '$950,000',
    statusColor: 'red'
  }];
  return <div className="min-h-screen bg-gray-50" data-id="element-65">
      <Header username="Carlos Pérez" onMenuClick={handleMenuToggle} notificationCount={3} data-id="element-66" />
      <NavigationMenu isOpen={menuOpen} onClose={() => setMenuOpen(false)} data-id="element-67" />
      <main className="p-4 pb-20" data-id="element-68">
        <h1 className="text-xl font-semibold mb-4" data-id="element-69">Gestión de Acuerdos</h1>
        {/* Filters */}
        <div className="mb-6" data-id="element-70">
          <div className="flex space-x-2 overflow-x-auto pb-2" data-id="element-71">
            <button className="px-4 py-2 bg-blue-600 text-white rounded-lg whitespace-nowrap" data-id="element-72">
              Todos
            </button>
            <button className="px-4 py-2 bg-white border border-gray-300 rounded-lg whitespace-nowrap" data-id="element-73">
              Activos
            </button>
            <button className="px-4 py-2 bg-white border border-gray-300 rounded-lg whitespace-nowrap" data-id="element-74">
              Pendientes
            </button>
            <button className="px-4 py-2 bg-white border border-gray-300 rounded-lg whitespace-nowrap" data-id="element-75">
              Vencidos
            </button>
          </div>
        </div>
        {/* Agreements List */}
        <div className="space-y-4" data-id="element-76">
          {agreements.map(agreement => <Card key={agreement.id} className="cursor-pointer" data-id="element-77">
              <div className="flex justify-between items-center mb-2" data-id="element-78">
                <h3 className="font-medium" data-id="element-79">{agreement.client}</h3>
                <span className={`px-2 py-1 text-xs rounded-full text-white bg-${agreement.statusColor}-500`} data-id="element-80">
                  {agreement.status}
                </span>
              </div>
              <div className="grid grid-cols-2 gap-2 text-sm mb-2" data-id="element-81">
                <div data-id="element-82">
                  <span className="text-gray-500" data-id="element-83">ID: </span>
                  {agreement.id}
                </div>
                <div data-id="element-84">
                  <span className="text-gray-500" data-id="element-85">Fecha: </span>
                  {agreement.date}
                </div>
                <div className="col-span-2" data-id="element-86">
                  <span className="text-gray-500" data-id="element-87">Valor: </span>
                  <span className="font-medium" data-id="element-88">{agreement.value}</span>
                </div>
              </div>
              <div className="flex justify-end" data-id="element-89">
                <ChevronRightIcon size={20} className="text-gray-400" data-id="element-90" />
              </div>
            </Card>)}
        </div>
      </main>
    </div>;
};
export default AgreementManagement;